<template lang="pug">
li.menu-item.text-primary-text(ref="menu", :key="item.categoryId")
  button.gtm-function.w-full.flex.items-center.min-h-12(class="p-1 xl:min-h-0", :class="{ active: active || isExpand }", type="button", data-location="lobby", :data-icon="(item.name || {})['en-US']", :disabled="item.disabled", @click.stop="click(item)")
    .menu-icon.flex.flex-col.justify-center.items-center.overflow-hidden.shrink-0
      .w-full.h-full.overflow-hidden
        img.w-full(:src="item.isGame ? item.image || defaultGameImage : getImage", :alt="getRoomName(item)")
    .flex.items-center.overflow-hidden.flex-1
      span.truncate.text-sm {{ getRoomName(item) }}
      .sidebar-badge(class="mt-[-0.5rem]")
        img.ms-1.w-4.h-3(v-if="getBadge(item).mode === 'IMAGE'", :src="getBadge(item).value")
        span.ms-1.text-custom.text-primary-highlight(v-if="getBadge(item).mode === 'TEXT'", :style="`color:${getBadge(item).color}`", class="portrait:text-xs") {{ getBadge(item).value }}
    .w-6.h-6.flex.items-center.justify-center(v-if="item.sub?.length", @click.stop="matchClick(!isExpand)")
      img.inline-block.w-3.h-2.transition(:class="{ '-rotate-180': isExpand }", :src="dropdownIcon")
  ul.menu-sub-list.overflow-hidden.transition-all.ease-in-out.duration-200(:class="{ 'h-0': !isExpand }")
    client-only
      MenuItem(v-for="subItem in item.sub", class="px-1", :key="subItem.categoryId", :item="subItem", :parents="[...parents, cleanItem]", :menuItemStack="menuItemStack", :historyStack="historyStack", @click="emitClick", @backward="$emit('backward')")
</template>

<script setup>
import dropdownIcon from 'assets/images/common/frame_icon_dropdown_normal.png'
import defaultImage from 'assets/images/side/idxcategory_icon_default_both.png'
import defaultGameImage from 'assets/images/side/idxcategory_icon_egame_both.png'
import backwardImage from 'assets/images/side/idxcategory_icon_forward_both.png'
import { ref, computed, onMounted, watch } from 'vue'

import { useI18n } from '#imports'

const props = defineProps({
  item: Object,
  menuItemStack: Array,
  historyStack: Array,
  parents: {
    type: Array,
    default: () => [],
  },
})

const emit = defineEmits(['click', 'backward'])

const { locale } = useI18n()

const active = ref(false)
const isExpand = ref(false)

onMounted(() => {
  const { menuItemStack, item } = props
  const hasMenuItemStack = menuItemStack?.some((menuItem) => item.categoryId === menuItem.categoryId)
  isExpand.value = hasMenuItemStack
  active.value = hasMenuItemStack
})

const cleanItem = computed(() => {
  const itemBuffer = { ...props.item }
  // 添加 parents 的時候不需要看 sub
  delete itemBuffer.sub
  return itemBuffer
})

const getImage = computed(() => {
  return props.historyStack?.some((history) => props.item.categoryId === history.categoryId) ? backwardImage : props.item.image || defaultImage
})

const getRoomName = (item) => {
  return item.name?.[locale.value] || item.name?.['en-US']
}

const getBadge = (item) => {
  const defaultBadge = {
    mode: '',
    color: '',
    value: '',
  }
  // 判斷當前badge模式
  switch (item.badgesDisplayMode?.pwa) {
    case 'IMAGE':
      // 防呆: 必免沒有圖片網址
      if (item.badgesImage?.pwa) {
        return {
          mode: 'IMAGE',
          value: item.badgesImage?.pwa,
        }
      } else {
        return defaultBadge
      }
    case 'TEXT':
      // 防呆: 避免沒有文字,避免當前語系無對應文字
      if (item.badgesI18n[locale.value] || item.badgesI18n['en-US']) {
        return {
          mode: 'TEXT',
          color: item?.badgesColor.pwa,
          value: item.badgesI18n[locale.value] || item.badgesI18n['en-US'],
        }
      } else {
        return defaultBadge
      }
    default:
      return defaultBadge
  }
}

const matchClick = (status) => {
  isExpand.value = status
}

const click = (item) => {
  if ((item.sub || [])[0]?.isGame || !item.categoryId || (item.sub || [])[0]?.categoryId === parseInt(props.menuItemStack.slice(-1)[0])) {
    isExpand.value = !isExpand.value
  }
  item.parents = props.parents || []

  if (props.historyStack?.some((history) => props.item.categoryId === history.categoryId)) {
    emit('backward')
    return
  }

  emit('click', item)
}

const emitClick = (item) => {
  emit('click', item)
}

watch(
  () => props.menuItemStack,
  (newData) => {
    const hasMenuItemStack = newData.some((menuItem) => props.item.categoryId === menuItem.categoryId)
    isExpand.value = hasMenuItemStack
    active.value = hasMenuItemStack
  }
)
</script>

<style scoped>
@reference "@/assets/css/tailwind.css";

.menu-item {
  @apply relative;
  font-size: 18px;
}

.menu-item button.active {
  @apply bg-linear-to-b from-menu-active-from to-menu-active-to;
}

.menu-item:not(:last-child)::before {
  content: '';
  position: absolute;
  bottom: -0.0625rem;
  inset-inline-start: 0.375rem;
  inset-inline-end: 0.375rem;
  height: 0.0625rem;
  background-color: rgba(0, 0, 0, 0.4);
}

.menu-item:not(:last-child)::after {
  content: '';
  position: absolute;
  bottom: -0.125rem;
  inset-inline-start: 0.375rem;
  inset-inline-end: 0.375rem;
  height: 0.0625rem;
  background-color: rgba(255, 255, 255, 0.2);
}

.menu-item button:disabled {
  filter: grayscale(1);
}

.menu-icon {
  width: 32px;
  height: 32px;
  margin-inline-end: 8px;
}
</style>
